import React from 'react'
import { Link } from 'react-router-dom'
import './claimstatusfooter.scss'
const ClaimStatusFooter = () => {
  return (
    <div className='claim-status-footer'>
      <div className='link-lists'>
        <span><Link to="#/"></Link>Terms and conditions</span>
        <span>|</span>
        <span><Link to="#/"></Link>Privacy</span>
        <span>|</span>
        <span><Link to="#/"></Link>Contact</span>
        <span>|</span>
        <span><Link to="#/"></Link>Español</span>
        <span>|</span>
        <span><Link to="#/"></Link>800-473-6879</span>
      </div>
    </div>
  )
}

export default ClaimStatusFooter
